export const defaultPythonCode = `siblings = 2
print ("I have " + str(siblings) + " siblings.")

cousins = 8
print ("I have " + str(cousins) + " cousins.")
`

export const defaultJavaScriptCode = `function setup() {
  createCanvas(400, 400);
  colorMode(HSB);
}

function draw() {
  background(220);
  noStroke();
  for (let i = 0; i < 12; i++){
    fill (360 - i * 25, 100, 100);
    rect (0, i * height / 12, width, height / 12);
  }
}
`
